import { Row } from "@sa/rep-mdde";
import { OLAPResult } from "@sa/rep-olap";
import { groupBy } from "lodash";

const groupKeys = ["calendar.default", "Measures"];
const UNITS_AXIS = "units.default";

export function transformOlapData(olapResult: OLAPResult): OLAPResult {
  const {
    data: { rows },
  } = olapResult;

  const groupedRows = groupBy(rows, ({ selection }) => {
    return groupKeys.map((e) => `${e}:${selection[e]}`).join("::");
  });
  const groups = Object.keys(groupedRows).map((e) => groupedRows[e]);

  const newRows = groups
    .map((group) => {
      if (group.length > 0) {
        const [{ selection: groupSelection }] = group;

        const cells = group.flatMap(({ selection, cells }) => {
          const nonEmptyCells = cells.filter((c) => c.value != null);
          nonEmptyCells.map((cell) => {
            const unit = selection[UNITS_AXIS] as string;
            cell.selection[UNITS_AXIS] = unit;
            return cell;
          });
          return nonEmptyCells;
        });

        return ({ selection: groupSelection, cells } as unknown) as Row;
      }

      return null;
    })
    .filter(Boolean) as any;

  const payload = {
    ...olapResult,
    data: {
      ...olapResult.data,
      rows: newRows,
    },
  };

  return payload;
}
